import React from 'react';
import type { CheckboxProps } from '@milanote/roma';

import DecimalFormatOptions from './DecimalFormatOptions';
import CurrencyFormatOptions from './CurrencyFormatOptions';
import DateFormatOptions from './DateFormatOptions';

import type {
    CellTypeFormatChanges,
    CurrencyTypeObject,
    DateTimeTypeObject,
    NumberTypeObject,
    PercentageTypeObject,
} from '../../../../../common/table/TableTypes';

type Props<T extends NumberTypeObject | CurrencyTypeObject | PercentageTypeObject | DateTimeTypeObject> = {
    cellTypeObject: T;
    updateCellTypeFormat: (cellTypeFormatChanges: CellTypeFormatChanges) => void;
    locale: string;
    formSize: CheckboxProps['size'];
};

export const NumberCellTypeOptions: React.FC<Props<NumberTypeObject>> = DecimalFormatOptions;
export const PercentageCellTypeOptions: React.FC<Props<PercentageTypeObject>> = DecimalFormatOptions;
export const DateTimeCellTypeOptions: React.FC<Props<DateTimeTypeObject>> = DateFormatOptions;

export const CurrencyCellTypeOptions: React.FC<Props<CurrencyTypeObject>> = (props) => {
    return (
        <>
            <DecimalFormatOptions {...props} />
            <CurrencyFormatOptions {...props} />
        </>
    );
};
